import { useSelector } from "react-redux";
import { Switch, Route } from "react-router-dom";
import { PermissionMenuName } from "../interfaces/UserRole";
import { BentukKerjasamaListPage } from "../pages/bentuk-kerjasama/BentukKerjasamaListPage";
import { BentukKerjasamaUpdatePage } from "../pages/bentuk-kerjasama/BentukKerjasamaUpdatePage";

import { DokumenKerjasamaDetailPage } from "../pages/dokumen-kerjasama/detail/DokumenKerjasamaDetailPage";
import { DokumenKerjasamaExportExcecl } from "../pages/dokumen-kerjasama/DokumenKerjasamaExportExcel";
import { DokumenKerjasamaListPage } from "../pages/dokumen-kerjasama/DokumenKerjasamaListPage";

import { HomePage } from "../pages/home/HomePage";
import { PermissionBlockedPage } from "../pages/home/PermissionBlockedPage";

import { JenisDokumenListPage } from "../pages/jenis-dokumen/JenisDokumenListPage";
import { JenisDokumenUpdatePage } from "../pages/jenis-dokumen/JenisDokumenUpdatePage";
import { JenisLembagaListPage } from "../pages/jenis-lembaga/JenisLembagaListPage";
import { JenisLembagaUpdatePage } from "../pages/jenis-lembaga/JenisLembagaUpdatePage";

import { MonevDetailPage } from "../pages/monev-partner/detail/MonevDetailPage";
import { MonevReportPage } from "../pages/monev-partner/MonevReportPage";

import { PartnerListPage } from "../pages/partner/PartnerListPage";
import { PartnerUpdatePage } from "../pages/partner/PartnerUpdatePage";

import { StatusKerjasamaListPage } from "../pages/status-kerjasama/StatusKerjasamaListPage";
import { StatusKerjasamaUpdatePage } from "../pages/status-kerjasama/StatusKerjasamaUpdatePage";

import { UserListPage } from "../pages/user-control/UserListPage";
import { UserUpdatePage } from "../pages/user-control/UserUpdatePage";

import { UserRoleListPage } from "../pages/user-role/UserRoleListPage";
import { UserRoleUpdatePage } from "../pages/user-role/UserRoleUpdatePage";
import { RootState } from "../store/rootReducer";

export const Routes = () => {
  const authorizedUser =  useSelector((state: RootState) => state.authorization.authorizedUser);
  const systemAccess =  useSelector((state: RootState) => state.authorization.systemAccess);
  
  const checkPermission = (allowed: boolean, component: JSX.Element) => {
    if (allowed) {
      return component;
    } else {
      return <PermissionBlockedPage />
    }
  }

  if (!authorizedUser) return null;

  return (
    <Switch>
      {/* Dokumen Kerjasama */}
      <Route path="/dokumen-kerjasama/export">
        {checkPermission(
          systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS.read,
          <DokumenKerjasamaExportExcecl />
        )}
      </Route>
      <Route path="/dokumen-kerjasama/create">
        {checkPermission(
          systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS.create,
          <DokumenKerjasamaDetailPage />
        )}
      </Route>
      <Route path="/dokumen-kerjasama/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS.read,
          <DokumenKerjasamaDetailPage />
        )}
      </Route>
      <Route path="/dokumen-kerjasama">
        {checkPermission(
          systemAccess[PermissionMenuName.dokumenKerjasama].ACCESS.read,
          <DokumenKerjasamaListPage />
        )}
      </Route>

      {/* Monev */}
      <Route path="/monev/report/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.monevPartner].ACCESS.read,
          <MonevReportPage />
        )}
      </Route>
      <Route path="/monev/:dok/create">
        {checkPermission(
          systemAccess[PermissionMenuName.monevPartner].ACCESS.create || systemAccess[PermissionMenuName.monevPartner].ACCESS.read,
          <MonevDetailPage />
        )}
      </Route>
      <Route path="/monev/:dok/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.monevPartner].ACCESS.read,
          <MonevDetailPage />
        )}
      </Route>

      {/* Master Perusahaan */}
      <Route path="/partner/create">
        {checkPermission(
          systemAccess[PermissionMenuName.partner].ACCESS.create,
          <PartnerUpdatePage />
        )}
      </Route>
      <Route path="/partner/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.partner].ACCESS.read,
          <PartnerUpdatePage />
        )}
      </Route>
      <Route path="/partner">
        {checkPermission(
          systemAccess[PermissionMenuName.partner].ACCESS.read,
          <PartnerListPage />
        )}
      </Route>

      {/* Master Data */}
      <Route path="/bentuk-kerjasama/create">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.create,
          <BentukKerjasamaUpdatePage />
        )}
      </Route>
      <Route path="/bentuk-kerjasama/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <BentukKerjasamaUpdatePage />
        )}
      </Route>
      <Route path="/bentuk-kerjasama">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <BentukKerjasamaListPage />
        )}
      </Route>

      <Route path="/jenis-dokumen/create">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.create,
          <JenisDokumenUpdatePage />
        )}
      </Route>
      <Route path="/jenis-dokumen/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <JenisDokumenUpdatePage />
        )}
      </Route>
      <Route path="/jenis-dokumen">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <JenisDokumenListPage />
        )}
      </Route>

      <Route path="/jenis-lembaga/create">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.create,
          <JenisLembagaUpdatePage />
        )}
      </Route>
      <Route path="/jenis-lembaga/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <JenisLembagaUpdatePage />
        )}
      </Route>
      <Route path="/jenis-lembaga">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <JenisLembagaListPage />
        )}
      </Route>

      <Route path="/status-kerjasama/create">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.create,
          <StatusKerjasamaUpdatePage />
        )}
      </Route>
      <Route path="/status-kerjasama/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <StatusKerjasamaUpdatePage />
        )}
      </Route>
      <Route path="/status-kerjasama">
        {checkPermission(
          systemAccess[PermissionMenuName.masterData].ACCESS.read,
          <StatusKerjasamaListPage />
        )}
      </Route>

      {/* User Management */}
      <Route path="/user-control/create">
        {checkPermission(
          systemAccess[PermissionMenuName.userControl].ACCESS.create,
          <UserUpdatePage />
        )}
      </Route>
      <Route path="/user-control/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.userControl].ACCESS.read,
          <UserUpdatePage />
        )}
      </Route>
      <Route path="/user-control">
        {checkPermission(
          systemAccess[PermissionMenuName.userControl].ACCESS.read,
          <UserListPage />
        )}
      </Route>
      
      {/* Role Management */}
      <Route path="/user-role/create">
        {checkPermission(
          systemAccess[PermissionMenuName.userRole].ACCESS.create,
          <UserRoleUpdatePage />
        )}
      </Route>
      <Route path="/user-role/:id">
        {checkPermission(
          systemAccess[PermissionMenuName.userRole].ACCESS.read,
          <UserRoleUpdatePage />
        )}
      </Route>
      <Route path="/user-role">
        {checkPermission(
          systemAccess[PermissionMenuName.userRole].ACCESS.read,
          <UserRoleListPage />
        )}
      </Route>

      <Route path="/">
        <HomePage />
      </Route>
    </Switch>
  );
}